import defaultReducers from '@src/models/defaultReducers'
import { InsurancePoliciesQuery } from '../graphql/fetchInsurancePolicies.generated'
import { InsuranceStatusStoreState } from './insuranceStatus.types'

export const reducers = {
  ...defaultReducers,
  updateInsurancePolicies: (
    state: InsuranceStatusStoreState,
    { payload }: { payload: InsurancePoliciesQuery['insurancePolicies'] },
  ) => {
    return {
      ...state,
      insurancePolicies: payload,
    }
  },
}

export default reducers
